module.exports = __webpack_public_path__ + "media/components/country-flag/static/by-417d52d05c31f5ee2cdd9ad4a0dac3f4.svg";